import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);
const routes = [
  {
    path: "/",
    name: "index",
    component: () =>
      import(/* webpackChunkName: "index" */ "../page/index/index.vue"),
    meta: {
      breadcrumb: "首页",
      menu: true
      // requireAuth: true //表示进入这个路由是需要登录的
    }
  },
  {
    path: "/newDt",
    name: "newDt",
    component: () =>
      import(/* webpackChunkName: "more" */ "../page/newDt/index.vue"),
    meta: {
      breadcrumb: "最新动态",
      menu: true
      // requireAuth: true //表示进入这个路由是需要登录的
    }
  },
  {
    path: "/newDtPage",
    name: "newDtPage",
    component: () =>
      import(/* webpackChunkName: "more" */ "../page/newDt/page.vue"),
    meta: {
      breadcrumb: "最新动态",
      menu: true
      // requireAuth: true //表示进入这个路由是需要登录的
    },
    children: [{
      path: "/newDtPageDetail",
      name: "newDtPageDetail",
      component: () =>
        import(/* webpackChunkName: "more" */ "../page/newDt/pageDetail.vue"),
      meta: {
        breadcrumb: "最新动态详情页",
        menu: true
        // requireAuth: true //表示进入这个路由是需要登录的
      }
    },]
  },
  {
    path: "/aboutUs",
    name: "aboutUs",
    component: () =>
      import(
        /* webpackChunkName: "information" */ "../page/aboutUs/index.vue"
      ),
    meta: {
      breadcrumb: "关于我们",
      menu: true
    }
  }, 
  {
    path: "/zcFg",
    name: "zcFg",
    component: () =>
      import(
        /* webpackChunkName: "information" */ "../page/zcFg/index.vue"
      ),
    meta: {
      breadcrumb: "政策法规",
      menu: true
    }
  }, {
    path: "/zcFgPage",
    name: "zcFgPage",
    component: () =>
      import(
        /* webpackChunkName: "information" */ "../page/zcFg/page.vue"
      ),
    meta: {
      breadcrumb: "政策法规",
      menu: true
    },
    children: [{
      path: "/zcFgPageDetail",
      name: "zcFgPageDetail",
      component: () =>
        import(
          /* webpackChunkName: "information" */ "../page/zcFg/pageDetail.vue"
        ),
      meta: {
        breadcrumb: "政策法规详情",
        menu: true
      }
    },]
  },{
    path: "/space",
    name: "space",
    component: () =>
      import(
        /* webpackChunkName: "information" */ "../page/space/index.vue"
      ),
    meta: {
      breadcrumb: "办公",
      menu: true
    }
  },{
    path: "/spacePage",
    name: "spacePage",
    component: () =>
      import(
        /* webpackChunkName: "information" */ "../page/space/page.vue"
      ),
    meta: {
      breadcrumb: "办公",
      menu: true
    },
    children: [{
      path: "/spacePageDetail",
      name: "spacePageDetail",
      component: () =>
        import(
          /* webpackChunkName: "information" */ "../page/space/pageDetail.vue"
        ),
      meta: {
        breadcrumb: "办公项目详情",
        menu: true
      },
      // children: [{
      //   path: "/pageBuildingDetail",
      //   name: "pageBuildingDetail",
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "information" */ "../page/space/pageBuildingDetail.vue"
      //     ),
      //   meta: {
      //     breadcrumb: "办公房源详情",
      //     menu: true
      //   }
      // },]
    },]
  },{
    path: "/pageBuildingDetail",
      name: "pageBuildingDetail",
      component: () =>
        import(
          /* webpackChunkName: "information" */ "../page/space/pageBuildingDetail.vue"
        ),
      meta: {
        breadcrumb: "办公房源详情",
        menu: true
      }
  },{
    path: "/business",
    name: "business",
    component: () =>
      import(
        /* webpackChunkName: "information" */ "../page/businessSpace/index.vue"
      ),
    meta: {
      breadcrumb: "商业",
      menu: true
    }
  },{
    path: "/businessPage",
    name: "businessPage",
    component: () =>
      import(
        /* webpackChunkName: "information" */ "../page/businessSpace/page.vue"
      ),
    meta: {
      breadcrumb: "商业",
      menu: true
    },
    children: [{
      path: "/businessPageDetail",
      name: "businessPageDetail",
      component: () =>
        import(
          /* webpackChunkName: "information" */ "../page/businessSpace/pageDetail.vue"
        ),
      meta: {
        breadcrumb: "商业详情",
        menu: true
      },
      // children: [{
      //   path: "/pageBusinessBuildingDetail",
      //   name: "pageBusinessBuildingDetail",
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "information" */ "../page/businessSpace/pageBuildingDetail.vue"
      //     ),
      //   meta: {
      //     breadcrumb: "商业房源详情",
      //     menu: true
      //   }
      // },]
    },]    
  },{
    path: "/pageBusinessBuildingDetail",
      name: "pageBusinessBuildingDetail",
      component: () =>
        import(
          /* webpackChunkName: "information" */ "../page/businessSpace/pageBuildingDetail.vue"
        ),
      meta: {
        breadcrumb: "商业房源详情",
        menu: true
      }
  },{
    path: "/findAddress",
    name: "findAddress",
    component: () =>
      import(
        /* webpackChunkName: "information" */ "../page/findAddress/index.vue"
      ),
    meta: {
      breadcrumb: "委托选址",
      menu: true
    }
  },{
    path: "/publishSpace",
    name: "publishSpace",
    component: () =>
      import(
        /* webpackChunkName: "information" */ "../page/publishSpace/index.vue"
      ),
    meta: {
      breadcrumb: "发布房源",
      menu: true
    }
  },
  {
    path: "/mapIndex",
    name: "mapIndex",
    component: () =>
      import(
        /* webpackChunkName: "information" */ "../page/map/index.vue"
      ),
    meta: {
      breadcrumb: "地图",
      menu: true
    }
  }, {
    path: "/cxxqDj",
    name: "cxxqDj",
    component: () =>
      import(
        /* webpackChunkName: "information" */ "../page/cxxqDj/index.vue"
      ),
    meta: {
      breadcrumb: "创新需求登记",
      menu: true
    }
  },{
    path: "/personalCenter",
    name: "personalCenter",
    component: () =>
      import(
        /* webpackChunkName: "information" */ "../page/personalCenter/index.vue"
      ),
    meta: {
      breadcrumb: "个人中心",
      menu: true
    }
  },
];

const router = new VueRouter({
  mode: "hash",
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 期望滚动到哪个位置
    return {
      x: 0,
      y: 0
    }
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js